import { render, staticRenderFns } from "./ProfileUniqueSipAgent.vue?vue&type=template&id=18a92d24&"
import script from "./ProfileUniqueSipAgent.vue?vue&type=script&lang=js&"
export * from "./ProfileUniqueSipAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports